import { render, staticRenderFns } from "./discount-time-detail.vue?vue&type=template&id=363b3d25&"
import script from "./discount-time-detail.vue?vue&type=script&lang=js&"
export * from "./discount-time-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports